import { createSlice } from "@reduxjs/toolkit";

const roleSlice = createSlice({
  name: "roles",
  initialState: { list: [] },
  reducers: {
    setAllRoles: (state, action) => { state.list = action.payload; },
    removeRole: (state, action) => {
      state.list = state.list.filter((r) => r.roleId !== action.payload);
    },
  },
});

export const { setAllRoles, removeRole } = roleSlice.actions;
export default roleSlice.reducer;
